import { ThemeNameType } from "@/tailwind-config/theme.constants";
import { FC } from "react";

export type ThemeWrapperProps = {
  theme: ThemeNameType;
  children: React.ReactNode;
  className?: string;
}

const ThemeWrapper: FC<ThemeWrapperProps> = ({ theme, className, children }) => {
  const wrapperProps = { 'data-theme': theme };

  return <div {...wrapperProps} className={className}>
    {children}
  </div>;
};

export default ThemeWrapper;
